import React, { useState } from 'react';
import BasicDetails from './BasicDetails'
import OTP from './OTP'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import Password from './Password'
import BankDetails from './BankDetails'
import ErrorPopup from './ErrorPopup'
import Completed from './Completed';
import { useSelector } from 'react-redux';
import ToastError from '../../dialog/toastError'
import Info from '../../dialog/GeneralDialog'
import Error from '../../dialog/dialogError'
import Prerequisite from './Prerequisite';
import Ekyc from './Ekyc';
import EkycPreError from './EkycPreError';
import EkycPost from './EkycPostProcess'
import EkycPostError from './EkycPostError'
import CddError from './CddError'
import CustomDialog from '../../dialog/CustomDialog'
import RetryDialog from '../../dialog/EkycRetryCustomDialog'
import EKYCNameAndNicUpdate from './EKYCNameAndNICUpdate'

const SignUp = () => {

  const step = useSelector(state => state.auth.step);
  const dialog = useSelector(state => state.auth.dialog);
  const kycDialog = useSelector(state => state.auth.kycDialog);


  const handleStep = (stepper) =>{

    let query = new URLSearchParams(useLocation().search);
    
    const referenceId=query.get("referenceId");
    const acquisitionStatus=query.get("acquisitionStatus");
    
    console.info("referenceId->"+referenceId+" | acquisitionStatus->"+acquisitionStatus+" | step->"+step);
    
    if(referenceId!==null&&step===0){
      return<EkycPost referenceId={referenceId} action='signup'/>
    }

    switch (stepper) {
      case 0:
        return <Prerequisite />
      case 1:
        return <BasicDetails />
      case 2:
        return <OTP />
      case 3:
        return <Ekyc/>
      case 4:
        return <Password />
      case 5:
        return <BankDetails />
      case 6:
        return <Completed />
      case 100:
        return <EkycPreError />
      case 200:
        return <CddError/>
      case 300:
        return <EKYCNameAndNicUpdate/>
      default:
        return <ErrorPopup />;
    }
  }

  const handleError = (dialog) =>{
    if (dialog && dialog.style) {
      switch (dialog.style) {
        case 'inline':
          return <ToastError />
        case 'toast':
          return <ToastError />
        case 'overlay':
          return <Info />
        case 'dialog-error':
          return <Error />
        case 'customDialog':
          return <CustomDialog/>
        case 'retryDialog':
          return <RetryDialog/>
        default:
          return '';
      }    
    }
  }

  return (
    <>
      {handleStep(step)}
      {handleError(dialog)}
    </>
  );
};

export default SignUp;
